import {
  MEASUREMENT_MAP_SLOT_KEYS,
  OPS_YEAR_STANDS_SLOT_KEY,
  REPORT_RANKED_SPATIAL_MAP_SLOT_KEY,
  STAND_INSPECTION_MAP_SLOT_KEY,
  STAND_MULTI_SELECT_MAP_SLOT_KEY,
  WORKSPACE_PRIMARY_MAP_SLOT_KEY,
  registerLazyMapSlot,
} from './mapSlotRegistry';
import {
  BUYER_DECODE_WORKFLOW_SLOT_KEY,
  PROPERTY_PACKAGE_WORKFLOW_SLOT_KEY,
  STAND_CORRECTION_WORKFLOW_SLOT_KEY,
  STAND_SIMULATION_WORKFLOW_SLOT_KEY,
  registerLazyReportWorkflowSlot,
} from './reportWorkflowSlotRegistry';

/** Resolves a code-split renderer module; the app wraps it in its chunk-retry policy. */
export type SlotModuleLoader = <T>(
  factory: () => Promise<{ default: T }>,
) => Promise<{ default: T }>;

/**
 * The one list of governed map and workflow renderers. The app, Storybook and
 * the design-sync bundle each call this from their composition root, so a slot
 * a descriptor names resolves to the same renderer on every surface and never
 * depends on which module happened to load first.
 */
export function registerApplicationSlots(load: SlotModuleLoader): void {
  registerLazyMapSlot(WORKSPACE_PRIMARY_MAP_SLOT_KEY, () =>
    load(() => import('@/components/Map/primaryMapWorkspaceSlot')),
  );
  MEASUREMENT_MAP_SLOT_KEYS.forEach((slotKey) => {
    registerLazyMapSlot(slotKey, () =>
      load(() => import('@/components/Map/primaryMapEmbeddedSlot')),
    );
  });
  registerLazyMapSlot(STAND_INSPECTION_MAP_SLOT_KEY, () =>
    load(() => import('@/components/stand/standInspectionMapSlot')),
  );
  registerLazyMapSlot(REPORT_RANKED_SPATIAL_MAP_SLOT_KEY, () =>
    load(() => import('@/components/Map/rankedSpatialMapSlot')),
  );
  registerLazyMapSlot(OPS_YEAR_STANDS_SLOT_KEY, () =>
    load(() => import('@/components/Map/opsYearStandsMapSlot')),
  );
  registerLazyMapSlot(STAND_MULTI_SELECT_MAP_SLOT_KEY, () =>
    load(() => import('@/components/Map/standMultiSelectMapSlot')),
  );
  registerLazyReportWorkflowSlot(STAND_SIMULATION_WORKFLOW_SLOT_KEY, () =>
    load(() => import('@/components/stand/SimulationModal')),
  );
  registerLazyReportWorkflowSlot(STAND_CORRECTION_WORKFLOW_SLOT_KEY, () =>
    load(() => import('@/components/stand/AddCorrectionDrawer')),
  );
  registerLazyReportWorkflowSlot(PROPERTY_PACKAGE_WORKFLOW_SLOT_KEY, () =>
    load(() => import('@/components/property/SubscriptionSelectionModal')),
  );
  registerLazyReportWorkflowSlot(BUYER_DECODE_WORKFLOW_SLOT_KEY, () =>
    load(() => import('@/shared/ui/FmCatalogPurchaseWorkflow')),
  );
}
